// style
export const imgSize = {
	search: 'w-full text-base border-2 pl-8 border-gray-300 bg-white pr-2 rounded-lg text-sm focus:outline-none appearance-none',
}
